import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "6.667",
      stroke: "#BEBEC9",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#BEBEC9",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8 8.667V8.51c0-.504.337-.77.675-.985.329-.208.658-.474.658-.963 0-.682-.594-1.23-1.333-1.23-.74 0-1.333.548-1.333 1.23M7.997 10.333h.006"
    }, null, -1)
  ]))]))
}
export default { render: render }